/*
 * @Author: your name
 * @Date: 2021-08-23 20:43:12
 * @LastEditTime: 2025-03-11 15:17:41
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \baishu_react_ui\src\App.js
 */
import React, { useEffect, useState } from 'react';
import Addressbook from './components/BsyAddressbook';
import BsyDashboard from './components/dashboard/BsyDashboard';

import BsyDashboardDesign from './components/dashboard/BsyDashboardDesign';
import BsyAppStore from './components/BsyAppStore';
import BsyWebhook from './components/BsyWebhook';
import BsyWebhookApi from './components/BsyWebhookApi';
import BsyWebhookApiDoc from './components/BsyWebhookApiDoc';
import BsyWebhookKey from './components/BsyWebhookKey';
import BsyWebhookSso from './components/BsyWebhookSso';
import Login from './Login/Login';
import './App.css';
import { Route, Switch, Redirect } from 'react-router-dom';
import BsyModulesPane from './components/BsyModulesPane';
import MyModules from './components/BsyModulesPane/myModules';
import BsyDataView from './components/BsyDataView';
import BsyQueryForm from './components/BsyQueryForm';
import BsyDashView from './components/dash/BsyDashView';
import BsyMirrorTip from './components/BsyMirrorTip';
import BsyDashboardUserApp from './components/dashboard/BsyDashboardUserApp';
import BsyCorpCoopInvite from './components/BsyCorpCoopInvite';
import BsyMsgDataView from './components/BsyMsgDataView';
import BsyFormView from './components/BsyFormView';
import BsySLoading from './components/BsySLoading';
import Auth from './auth';
import BsyStandardAppPane from './components/BsyStandardAppPane';
import BsyDashboardApp from './components/dashboard/BsyDashboardApp';

function App() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState(window.siteDevInfo);
    useEffect(() => {
        setLoading(true);
        if (!window.siteDevInfo) {
            React.axios('/team/getSiteDevInfo').then(res => {
                setData(res.data);
                window.siteDevInfo = res.data;
                window.media_domain = res.data.sitesetting.cdn_domain
                window.FX.CONST.QN_BUCKET.UPLOAD_SITE = window.FX.CONST.QN_BUCKET.UPLOAD_SITE || res.data._bby_config.UPLOAD_SITE
                window.FX.CONST.QN_BUCKET.IMAGE_HOST = window.FX.CONST.QN_BUCKET.IMAGE_HOST || res.data._bby_config.IMAGE_HOST
                window.FX.CONST.QN_BUCKET.SITE = window.FX.CONST.QN_BUCKET.SITE || res.data._bby_config.site
            }).catch(err => {
                setError(err);
            }).finally(() => {
                setLoading(false);
            });
        }

    }, []);
    if (loading) {
        return <BsySLoading style={{ background: '#f5f7fa' }} />;
    }
    if (error) {
        throw new Error(error.message);
    }
    return (
        <Switch>
            <Route path={window.rootDirectroy + '/team/design'}>
                <Auth>
                    <BsyDashboardDesign />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/user'}>
                <Login />
            </Route>
            <Route path={window.rootDirectroy + '/dingding'}>
                <Login />
            </Route>
            <Route path={window.rootDirectroy + '/corp/url/'}>
                <Login />
            </Route>
            <Route path={window.rootDirectroy + '/corp/login_setting'}>
                <Login />
            </Route>
            <Route path={window.rootDirectroy + '/corp/addressbook'}>
                <Auth>
                    <Addressbook />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/corp/dock_join'}>
                <Auth>
                    <BsyCorpCoopInvite />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/corp/tmpowner_accept'}>
                <Auth>
                    <BsyCorpCoopInvite />
                </Auth>
            </Route>

            <Route path={window.rootDirectroy + '/bsymember/appstore'}>
                <Auth>
                    <BsyAppStore />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/open/webhook'}>
                <Auth>
                    <BsyWebhook />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/open/modules'}>
                <Auth>
                    <BsyModulesPane />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/open/mymodules'}>
                <Auth>
                    <MyModules />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route
                path={window.rootDirectroy +
                    '/webapi/docinfo/:mode/:id/entry/:entryId'}
            >
                <Auth>
                    <BsyWebhookApiDoc />
                </Auth>
            </Route>
            <Route
                path={window.rootDirectroy +
                    '/webapi/docinfo/:mode/:id/:type'}>
                <Auth>
                    <BsyWebhookApiDoc />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/open/api'}>
                <Auth>
                    <BsyWebhookApi />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/open/key'}>
                <Auth>
                    <BsyWebhookKey />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/open/sso'}>
                <Auth>
                    <BsyWebhookSso />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/open'}>
                <Auth>
                    <BsyWebhook />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            {/* <Route path={window.rootDirectroy + '/team/release'}>
                <Auth>
                    <BsyStandardAppPane />
                    <BsyMirrorTip />
                </Auth>
            </Route> */}
            <Route path={window.rootDirectroy + '/team/standard/group/:groupid'}>
                <Auth>
                    <BsyStandardAppPane />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/standard/:type'}>
                <Auth>
                    <BsyStandardAppPane />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Redirect
                from={window.rootDirectroy + '/team/standard/'}
                to={window.rootDirectroy + '/team/standard/management'}
            />
            <Route path={window.rootDirectroy + '/dashboard/desing/:type'}>
                <Auth>
                    <BsyDashboardDesign />
                    <BsyMirrorTip />
                </Auth>
            </Route>

            <Route path={window.rootDirectroy + '/team/u/:id'}>
                <Auth>
                    <BsyDashboardUserApp />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/message/:id'}>
                <Auth>
                    <div className="bsy-dashboard ">
                        <div className={'content-pane message-view'}>
                            <BsyMsgDataView
                                appid={window.FX.STATIC.APPID}
                            />
                        </div>

                    </div>
                    <BsyMirrorTip />
                </Auth>
            </Route>

            <Route path={window.rootDirectroy + '/team/l/:id/data/:dataid'}>
                <BsyDataView />
            </Route>


            <Route path={window.rootDirectroy +
                '/team/app/:appid/form/:entryid/data/:dataid/:type/:flowid'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy +
                '/team/app/:appid/entry/:entryid/data/:dataid'}>
                <Auth>
                    <BsyDataView />
                    <BsyMirrorTip />
                </Auth>
            </Route>

            <Route path={window.rootDirectroy +
                '/team/app/:appid/form/:entryid/datamanage'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route
                path={window.rootDirectroy +
                    '/team/app/:appid/entry/:entryid'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/q/:innerlink'}>

                <BsyQueryForm />
                <BsyMirrorTip />

            </Route>
            <Route
                path={window.rootDirectroy +
                    '/team/app/:appid/:type/:entryid'}>
                <Auth>
                    <BsyDashboardApp />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/app/:appid'}>
                <Auth>
                    <BsyDashboardApp />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/group/:groupid'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/apps'  }>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/todo'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/cc'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/transactors'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/create'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/launch'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/team/appinstall/:id'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
            <Route path={window.rootDirectroy + '/r/:id'}
                component={BsyDashView} />
            <Route path={window.rootDirectroy + '/f/:id'}
                component={BsyFormView} />

            <Route path={window.rootDirectroy + '/'}>
                <Auth>
                    <BsyDashboard />
                    <BsyMirrorTip />
                </Auth>
            </Route>
        </Switch>
    );
}

export default App;
